import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Typography} from '@mui/material';
import {isConsiderCompletedSTR, STRStatusType} from '../hook/useSTRStatus';

interface Props {
  status: STRStatusType | null;
  startTime?: string;
  endTime?: string;
}

const formatTime = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    secs.toString().padStart(2, '0'),
  ].join(':');
};

const calculateSecondsDiff = (startTime: string, endTime?: string) => {
  const fromTime = new Date(startTime).getTime(); // UTC time
  const toTime = endTime ? new Date(endTime).getTime() : new Date().getTime(); // Current time in UTC
  return Math.floor((toTime - fromTime) / 1000); // Difference in seconds
};

const STRElapsedTimer: React.FC<Props> = ({status, startTime, endTime}) => {
  const [elapsedTime, setElapsedTime] = useState<number>(0);

  const elapsedTimerRef = useRef<NodeJS.Timer | undefined>(undefined);
  useEffect(() => {
    if (isConsiderCompletedSTR(status) && startTime) {
      clearInterval(elapsedTimerRef.current);
      setElapsedTime(calculateSecondsDiff(startTime, endTime));
    } else if (status === STRStatusType.InProgress && startTime) {
      setElapsedTime(calculateSecondsDiff(startTime));
      elapsedTimerRef.current = setInterval(() => {
        setElapsedTime(calculateSecondsDiff(startTime));
      }, 1000);
    } else {
      clearInterval(elapsedTimerRef.current);
      setElapsedTime(0);
    }
    return () => {
      clearInterval(elapsedTimerRef.current);
    };
  }, [status, startTime, endTime]);

  const eclapsedTime = useMemo(() => {
    return elapsedTime !== 0 ? formatTime(elapsedTime ?? 0) : '--';
  }, [elapsedTime]);

  return (
    <Typography className="typo-text body2_size field" tabIndex={0}>
      {eclapsedTime}
    </Typography>
  );
};

export default STRElapsedTimer;
